import { createSlice } from '@reduxjs/toolkit';

export interface IAddOrgState extends Record<string, any> {
  successModalOpened: boolean;
}

export const initialState: IAddOrgState = {
  successModalOpened: false,
};

const addOrgSlice = createSlice({
  name: 'addOrg',
  initialState,
  reducers: {
    openSuccessModal(state) {
      state.successModalOpened = true;
    },
    closeSuccessModal(state) {
      state.successModalOpened = false;
    },
  },
});

export const { openSuccessModal, closeSuccessModal } = addOrgSlice.actions;

export default addOrgSlice.reducer;
